// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { WSTabs } from "../../../Components/Tabs/WSTabs";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useForm } from "react-hook-form";
// import { PharmacyOrder } from "./PharmacyProductOrder";
// import { PrescriptionOrder } from "./PrescriptionOrder";

// export const PharmacyOrderList: React.FC<any> = React.memo((props) => {
//       const { control, handleSubmit } = useForm();
    
//      const tabsData: any[] = [
//     { label: "Pharmacy Product Order", content: <PharmacyOrder/> },
//     { label: "Prescription Order", content: <PrescriptionOrder/>},
//   ];

//    useEffect(() => {
//       updateMainHeader("Orders");
//     }, []);
  
//     breadCrumbsStore.updateBreadCrumbs([{ Orders: "pharmacy-orders/list" }]);
//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today Order"
//             value="40"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today Home Collections"
//             value="20"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Tests"
//             value="600"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Package"
//             value="400"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           <WSTabs
//             id="tabs"
//             control={control}
//             name="tabs"
//             tabs={tabsData}
//             justifyTabs="flex-start"
//           />
//         </Grid>
//       </Grid>
//     </>
//   );
// });






import { Grid } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useForm } from "react-hook-form";
import { PharmacyOrder } from "./PharmacyProductOrder";
import { PrescriptionOrder } from "./PrescriptionOrder";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

interface DashboardStats {
  totalOrders: number;
  pendingOrders: number;
  outOfStockProducts: number;
  totalEarnings: number;
  orders: any[];
}

export const PharmacyOrderList: React.FC<any> = React.memo((props) => {
  const { control, handleSubmit } = useForm();
  const [stats, setStats] = useState<DashboardStats>({
    totalOrders: 0,
    pendingOrders: 0,
    outOfStockProducts: 0,
    totalEarnings: 0,
    orders: []
  });
  const [loading, setLoading] = useState(true);
  
  const tabsData: any[] = [
    { label: "Pharmacy Product Order", content: <PharmacyOrder/> },
    { label: "Prescription Order", content: <PrescriptionOrder/>},
  ];

  // ✅ Fetch real dashboard stats from API
  // Replace your entire fetchDashboardStats with this:
const fetchDashboardStats = useCallback(async () => {
  try {
    setLoading(true);
    const vendorId = getLocalValue(LoacalVariables.UserId);
    if (!vendorId) return;
    
    console.log("🔄 Fetching with vendorId:", vendorId);
    
    const response: any = await http.get(`pharmacy/Ph_Order_/${vendorId}/orders`);
    
    console.log("📊 FULL API RESPONSE:", response);
    
    // ✅ FIXED: Type-safe response handling
    const apiData = (response as any)?.data || (response as any);
    
    console.log("📈 Extracted data:", apiData);
    
    setStats({
      totalOrders: Number(apiData?.totalOrders) || 0,
      pendingOrders: Number(apiData?.pendingOrders) || 0,
      outOfStockProducts: Number(apiData?.outOfStockProducts) || 0,
      totalEarnings: Number(apiData?.totalEarnings) || 0,
      orders: apiData?.orders || []
    });
    
  } catch (error: any) {
    console.error("❌ API ERROR:", error);
    setStats({
      totalOrders: 0,
      pendingOrders: 0,
      outOfStockProducts: 0,
      totalEarnings: 0,
      orders: []
    });
  } finally {
    setLoading(false);
  }
}, []);



  useEffect(() => {
    fetchDashboardStats();
  }, [fetchDashboardStats]);

  useEffect(() => {
    updateMainHeader("Orders");
  }, []);

  breadCrumbsStore.updateBreadCrumbs([{ Orders: "pharmacy-orders/list" }]);

  if (loading) {
    return (
      <Grid container spacing={2} justifyContent="center" alignItems="center" minHeight="200px">
        <Grid item>Loading dashboard...</Grid>
      </Grid>
    );
  }

  return (
    <>
      {/* ✅ REAL API DATA CARDS */}
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Total Orders"
            value={stats.totalOrders.toString()}
            percentage=""
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
            onClick={() => console.log("Total Orders clicked")}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Pending Orders"
            value={stats.pendingOrders.toString()}
            percentage=""
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.InStockIcon sx={{ color: "#ff9800" }} />}
            onClick={() => console.log("Pending Orders clicked")}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Out of Stock"
            value={stats.outOfStockProducts.toString()}
            percentage=""
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
            onClick={() => console.log("Out of Stock clicked")}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Total Earnings"
            value={`₹${stats.totalEarnings}`}
            percentage=""
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#4caf50" }} />}
            onClick={() => console.log("Earnings clicked")}
          />
        </Grid>
      </Grid>

      {/* ✅ TABS BELOW */}
      <Grid container spacing={2} mt={3} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSTabs
            id="tabs"
            control={control}
            name="tabs"
            tabs={tabsData}
            justifyTabs="flex-start"
          />
        </Grid>
      </Grid>
    </>
  );
});
